<template>
    <div ref="portfolio" class="portfolio d-flex justify-center flex-wrap">
        <v-card min-width="470" color="secondary ma-4">
            <div class="d-flex flex-no-wrap justify-space-between">
                <div>
                    <v-card-title>Pekin and Pekin Law</v-card-title>
                    <v-card-subtitle>Mendocino county law firm.</v-card-subtitle>
                    
                </div>
                <v-avatar
                    class="ma-4"
                    size="200"
                    tile>
                    <v-img :src="require('@/assets/Pekin_and_Pekin-Law-thumbnail.jpg')" />
                </v-avatar>
            </div>
            <v-card-actions class="d-flex justify-center">
                <v-btn width="100%" target="_blank" href="https://pekinandpekinlaw.com">Visit Website</v-btn>
            </v-card-actions>
        </v-card>
        <v-card min-width="470" color="secondary ma-4">
            <div class="d-flex flex-no-wrap justify-space-between">
                <div>
                    <v-card-title>Lodging and Llamas</v-card-title>
                    <v-card-subtitle>Lodging rentals and llama treks.</v-card-subtitle>
                </div>
                <v-avatar
                    class="ma-4"
                    size="200"
                    tile>
                    <v-img :src="require('@/assets/Lodging_and_Llamas-thumbnail.jpg')" />
                </v-avatar>
            </div>
            <v-card-actions class="d-flex justify-center">
                <v-btn width="100%" target="_blank" href="https://lodgingandllamas.com">Visit Website</v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>
<script>

export default {
  name: 'portfolio',
  components: {
  }
}
</script>